import { OverflowMenu } from "@carbon/react";

export const View = (props) => {
  return <OverflowMenu {...props} />;
};
